import React, { Component, Fragment, useLayoutEffect } from "react";
import { NavLink } from "react-router-dom";
import Header from "../account/Header";
import AccountNav from "../account/AccountNav";
import { plan } from "../../../services/membership";
import AppContext from "../../../contexts/AppContext";
import { create as addCard } from "../../../services/card";
import { manageSubscription } from "../../../services/billing";
import CancelModel from "./CancelModel";
import LoadingData from "../../utilities/LoadingData";
import ReactPayPal   from "../../PayPal/checkout/ReactPayPal";
import { PayPalButton } from "react-paypal-button-v2";
export class Membership extends Component {
    // const [checkout, setCheckout] = React.useState(false);
    state = {
        item: {},
        plan: [],
        errors: {},
        curSubscription:{},
        curSubscriptionState: '',
        state: "",
        card: [],
        cardResource: {},
        needPayment: false,
        needCard: false,
        paymentCompleted: false,
        needCoupon: false,
        cancel: false,
        loading: true,
        createM : false,
        payment_type:false,
        trial_on:false,
        user_payment_type:'',
    };
   
    componentDidMount() {   
        this.getData();
    }

    getData(messgae){
        setTimeout(() => {
            plan()
            .then(response => {                
                // var plandata = [];
                // if(response.meta)
                // {                   
                //     Object.entries(response.meta).map(([key, plans]) => {
                //         var d = {"id":plans.id,"value":plans.id,"name":plans.name+ " ($"+plans.price+")","label":plans.name+ " ($"+plans.price+")"};
                //         plandata.push(d);
                //     })
                // }
                // alert(response.data.payment_gateway);
                // console.log(response.data.user_id.plan.name);
                this.setState({
                    item: response.data,
                    curSubscription: response.data.plan_id,    
                    curSubscriptionState: response.data.state,
                    loading: false,
                    plan: response.meta,
                    cardResource: response.data.card,
                    payment_type:response.data.payment_gateway,
                    trial_on: response.data.trial_on,
                    user_payment_type: typeof response.data.user_id !== 'undefined'? response.data.user_id.payment_method:'Free'
                });
                // console.log(this.state.item.plan_name);
                this.setState({
                    loading: false,
                });
                if (messgae == 'updated') {
                    this.context.state.showCodeMessage(
                        "Subscription updated successfully.",
                        "success"
                    );
                }
                //console.log(this.state.item)
            })
            .catch(error => {
                this.context.state.handelError(error);
                this.setState({                  
                    loading: false,
                });
            });
        }, 1000)
    }
    addCard = item => {
        return addCard(item).then(response => {
            this.setState({
                needPayment: true,
                needCard: false
            });
        });
    };

    hideAll = () => {
        this.setState({
            needPayment: false,
            needCard: false,
            needCoupon: false,
            paymentCompleted: false,
            cancel: false
        });
        this.getData();
    };

    showCancel = () => {
        this.setState({
            cancel: true
        });
    };
    showAddCard = () => {
        this.setState({
            needPayment: false,
            needCard: true
        });
    };
    showPaymentSuccess = (messgae = null) => {
        this.setState({
            needPayment: false,
            needCard: false,
            paymentCompleted: true
        });       
        this.getData(messgae);
    };

    showPay = () => {
        this.setState({
            needPayment: true,
            needCard: false
        });
    };

    toggleCreate = () => {
        this.setState({ createM: this.state.createM === true ? false : true });
    };

    manageSubscriptions = (planId,pay_method='',order_id='') => {
        // alert(planId);
        // alert(pay_method);
        // return;
        if(this.state.curSubscriptionState !== 'PENDING_FOR_APPROVAL' || pay_method == 'paypal'){
        this.setState({ loading: true });
            manageSubscription({
                planid: planId,
                pay_method:pay_method,
                order_id:order_id             
            })
            .then(res => {
                this.showPaymentSuccess('updated');
                // this.context.state.showCodeMessage(
                //     "Subscription updated successfully.",
                //     "success"
                // );
                                                    
            })
            .catch(error => {
                this.setState({ loading: false });
                this.context.state.handelError(error);
            });
        }else{
            this.context.state.showCodeMessage(
                "Your last updated membership plan is still waiting for approval.",
                "error"
            );
        }
    };

    paypalApprove = (data, actions) => {
        let _this =this;
        // Capture the funds from the transaction
        return actions.order.capture().then(function(details) {
          // Show a success message to your buyer
          // OPTIONAL: Call your server to save the transaction
          _this.manageSubscriptions('lifetime','paypal',data.orderID);
        });
      };
    paypalCreateOrder = (data, actions) => {
        return actions.order.create({
          purchase_units: [{
            amount: {
              currency_code: this.context.state.paypal_currency,
              value: this.context.state.paypal_lifetime_plan_amount
            }
          }],
          // application_context: {
          //   shipping_preference: "NO_SHIPPING" // default is "GET_FROM_FILE"
          // }
        });
      };
    render() {
        return (
            <Fragment>
                <Header></Header>
                <div>
				    {/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Settings</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}
					<section className="settingsDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
						<div className="container writer-container">
							<div className="row">
								<div className="col-md-3">
							        <div className="card custom">
							            <div className="card-header">
							        	    Settings
							            </div>
                                        <div className="card-body">									
							        	    <nav className="custom-sidenav" id="myScrollspy">
                                            	<ul className="list-group">														
													<li><NavLink to={`/account/settings`} exact={true}>My Account</NavLink></li>
													<li className='active'><NavLink to={`/account/settings/membership`} exact={true}>Membership</NavLink></li>
													<li><NavLink to={`/account/settings/credits`} exact={true}>Credits</NavLink></li>
													<li><NavLink to={`/account/settings/payment-methods`} exact={true}>Payment Methods</NavLink></li>
													<li><NavLink to={`/account/settings/billing-history`} exact={true}>Billing History</NavLink></li>
                                            	</ul>
                                            </nav>
							        	</div>
							        </div>	
							    </div>
								<div className="col-md-9 mt-md-0 mt-4">									
                                    <div className="header">
                                        <div className="header-body">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h1 className="header-title">
                                                        Membership
                                                    </h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
									
									{this.state.loading === true ? <LoadingData></LoadingData> : Object.keys(this.state.item).length === 0 ? 
                                       
                                        // <div className="unlock-plus">
                                        //     <div className="row align-items-center">
                                        //         <div className="col-lg-2 mb-3 mb-lg-0">
                                        //             <img className="d-block m-auto m-lg-0 pr-0 pr-lg-4" src="/images/plus.png" alt="prowriter-plus"/>
                                        //         </div>
                                        //         <div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-lg-0 mb-md-3 mb-sm-0 mb-3 text-lg-left text-md-center text-sm-left text-center">
                                        //             <p>Launch and grow your freelance writing career by upgrading to <span>ProWriter Plus.</span></p>
                                        //         </div>
                                        //         <div className="col-lg-4 col-md-12 col-sm-6 col-12">
                                        //             <a href="/pricing" target="_blank" className="btn btn-primary d-block">Upgrade to Plus</a>
                                        //         </div>
                                        //     </div>
                                        // </div>
                                        <div className="card membership">
                                            <div className="plans">
                                                <h4>MANAGE PLANS</h4>
                                                <div className="row justify-content-center">
                                                    {this.state.plan.map(
                                                        (item, index) => {
                                                            return (
                                                                <div className="PlanDivs col-lg-4 col-sm-6 pl-xl-4 pr-xl-4" key={index}>
                                                                    <div className="single-price ">
                                                                        <div>
                                                                            <span> </span>
                                                                        </div>
                                                                        <div className="padded-box">
                                                                            <h3 className="color">{item.name}</h3>
                                                                            <div className="d-flex justify-content-center price-box hash ">
                                                                                <span>$</span>
                                                                                <span>{item.price}</span>
                                                                                <span>{item.sub}</span>
                                                                            </div>
                                                                            <button onClick={this.manageSubscriptions.bind(this, item.id)} type="button" className='btn btn-primary'>{`Upgrade to ${item.description}`}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    : 
                                        <div className="card membership">
                                            <div className="row">                                                                            
                                                <div className="col-sm-4 mb-4 mb-sm-0">
                                                    <h3 class="ml-0">Product</h3>
                                                    <p><b>Prowriter Plus</b></p>                                                   
                                                    {/* <p>{this.state.item.plan_name}</p> */}
                                                    <p>{this.state.item.user_id.plan.name}</p>
                                                    {this.state.item.trial_on === "Active" ? 
                                                        <p className="green">Trial: {this.state.item.trial_start} - {this.state.item.trial_end}</p>                                                        
                                                    : null}                                                    
                                                </div>
                                                <div className="col-sm-4 mb-4 mb-sm-0">                                                                                
                                                    <h3 class="ml-0"> Status & Renewal </h3>
                                                    <p className={this.state.item.color}>{this.state.item.state && this.state.item.state=='CANCELLED'?'CANCELED':this.state.item.state != 'PENDING_FOR_APPROVAL'?this.state.item.state:''}</p>
                                                    {this.state.item.state && this.state.item.state=='PENDING_FOR_APPROVAL'?
                                                    <p className="yellow">
                                                   Pending For Approval <i className="info fe fe-help-circle ml-3" data-toggle="tooltip" data-placement="top" title="Waiting for PayPal consent approval."></i></p>
                                                    :''}
                                                    <p>{this.state.item.state && this.state.item.state == 'PENDING_FOR_APPROVAL'?<a className="btn btn-success" target="_blank" href={this.state.item.paypal_approval_link}>Click here to approve</a> :''}</p>
                                                    {this.state.item.state && this.state.item.state !='PENDING_FOR_APPROVAL' && this.state.item.state !='CANCELLED'?
                                                    <p>Started On {this.state.item.start_date}</p>
                                                    :''}
                                                    {this.state.curSubscription.description === "Lifetime" ? "" : this.state.item.state && this.state.item.state !='PENDING_FOR_APPROVAL' && this.state.item.state !='CANCELLED'?
                                                        <p>Renews: {this.state.item.renew_date}</p>:''
                                                    }
                                                </div>
                                                <div className="col-sm-4">                                                                                
                                                    <h3 class="ml-0">Payment Method</h3>
                                                    {this.state.payment_type == '1' ?
                                                    // <div className="card align-items-center flex-row mb-3 border-0">
                                                    //     <img src={`/cards/${this.state.cardResource.type.charAt(0).toUpperCase() + this.state.cardResource.type.slice(1)}.png`} className="card-img-top card-brand" alt=""></img>
                                                    //     <div className="card-body p-0 d-flex align-items-center">
                                                    //         <div>
                                                    //             <h5 className="card-title pl-3 mb-1"><span className="mr-2">{this.state.cardResource.type}</span>•••• {this.state.cardResource.code}</h5>
                                                    //             <p className="card-text pl-3 m-0">Expires {this.state.cardResource.expiry}</p>
                                                    //         </div>
                                                    //     </div>
                                                    // </div>
                                                    <p className="card align-items-center flex-row mb-3 border-0"><b>Stripe</b></p> 
                                                    : <p className="card align-items-center flex-row  mb-3 border-0"><b>PayPal</b></p> 
                                                }
                                                    {this.state.item.subscription_coupon_id !== null ? 
                                                        <p><b>Coupon:</b> {this.state.item.SubscriptionCoupon.code}</p>
                                                    : ""}
                                                    
                                                    <p className="link"><NavLink to={`/account/settings/billing-history`}>View Statements</NavLink></p>
                                                </div>
											</div>	
											<div className="plans">
                                                <h4>MANAGE PLANS</h4>
                                                <div className="row justify-content-center">
                                                    {this.state.plan.map(
                                                        (item, index) => {
                                                            return (
                                                                <div className="PlanDivs col-lg-4 col-sm-6 pl-xl-4 pr-xl-4" key={index}>
																    <div className="single-price">
																	    <div>
						                                                    <span> </span>
						                                                </div>
																		<div className="padded-box d-flex flex-column">
                                                                            <h3 className="color">{item.name}</h3>
																			<div className="d-flex justify-content-center price-box hash ">
                                                                                <span>$</span>
																				<span>{item.price}</span>
																				<span>{item.sub}</span>
																			</div>
                                                                            { item.name =="PW Lifetime Membership" && this.state.user_payment_type =='PayPal'?
                                                                            // <ReactPayPal total={0.02}/>
                                                                            <div className="paypal-btn-div">
                                                                            <PayPalButton
                                                                            createOrder={this.paypalCreateOrder}
                                                                            onApprove={this.paypalApprove}
                                                                            options={{
                                                                                clientId:this.context.state.paypal_client_id
                                                                            }}
                                                                            style={{
                                                                                shape: 'rect',
                                                                                color: 'blue',
                                                                                layout: 'horizontal',
                                                                                label: 'pay',
                                                                                tagline:"false",
                                                                                height  :45
                                                                                }}
                                                                            />
                                                                            </div>
                                                                            :
                                                                            <button onClick={this.manageSubscriptions.bind(this, item.id)} type="button" className={this.state.curSubscriptionState == 'CANCELLED' ? 'btn btn-primary' : this.state.curSubscriptionState == 'PENDING_FOR_APPROVAL' && this.state.item.plan_id.id === item.id ? 'btn btn-warning': (item.price > this.state.curSubscription.price ? 'btn btn-primary' : 'btn btn-secondary')}>
                                                                                {this.state.curSubscriptionState == 'CANCELLED' ? ` ${item.description}` : (item.price > this.state.curSubscription.price ? `Upgrade to ${item.description}` :  this.state.curSubscriptionState == 'PENDING_FOR_APPROVAL' && this.state.item.plan_id.id === item.id? 'PENDING FOR APPROVAL':`Downgrade to ${item.description}`)}
                                                                            </button>
                                                                            
                                                            }
																		</div>
																	</div>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                            {this.state.curSubscriptionState == 'CANCELLED' || this.state.item.plan_name == 'PW Lifetime Membership' ? '' : <div className="cancelMembership"><button type="button" className="" onClick={this.showCancel}>Cancel my membership</button></div>}
                                            {this.state.cancel === true ? <CancelModel hideAll={this.hideAll}></CancelModel> : ""}
                                        </div>                                                                    
                                    }
								</div>
							</div>
						</div>
					</section>
				</div>
                                            
            </Fragment>
        );
    }
}

Membership.contextType = AppContext;
export default Membership;



// WEBPACK FOOTER //
// ./src/components/writer/billing/MemeberShip.js